import React, { Component } from "react";
import { Field, reduxForm, Form } from "redux-form";
import { Row, Col } from "react-bootstrap";
import countries from "../../../data/countries";
import { seedcastForm } from "../../../lib/forms";
import { If } from "react-extras";
import DropDownInput from "../../lib/drop-down-input";
import { userHasRole } from "../../../lib/user";
import UserRoles from "../../../constants/roles";
import Calendar from "react-calendar";
import "./stats_filter_form.scss";
import get from "lodash/get";

const noop = () => {};

class StatsFilterForm extends Component {
  constructor(props) {
    super(props);
    this.getEpisodesArray = this.getEpisodesArray.bind(this);
  }
  mapSelectToDropDownOptions(selectOptions, withSort = false) {
    let options = selectOptions.map(({ key, name }) => ({
      label: name,
      value: key,
    }));
    if (withSort) {
      options.sort((a, b) => a.label.localeCompare(b.label));
    }
    return options;
  }

  mapCountryToDropDownOptions(selectOptions) {
    return selectOptions.map(({ code, name }) => ({ label: name, value: code }));
  }

  renderCalendarPicker = ({ value, closePopup, onChange }) => (
    <div
      onClick={e => e.stopPropagation()}
      className={"flex-row-container calendar-picker-container"}>
      <Calendar
        value={get(this.props, "filters.startEndDate")}
        onChange={value => {
          this.props.change("startEndDate", value);
          this.props.change("timeRange", "custom");
          closePopup();
        }}
        selectRange={true}
      />
    </div>
  );

  render() {
    var episodes = this.getEpisodesArray();
    var isAdvertiser = userHasRole(this.props.user, UserRoles.Advertiser);
    var { device, os, app } = this.props.statsOptions;

    return (
      <Form className="form-group stats-filter-form" onSubmit={noop}>
        <Row>
          <Col xs={12} md={12}>
            <div className="time-range-toggles" />
            <div className="drop-down-group">
              <Field
                name="timeRange"
                options={[
                  { label: "All Time", value: "allTime", key: "allTime" },
                  { label: "12 Months", value: "year", key: "year" },
                  { label: "30 Days", value: "month", key: "month" },
                  { label: "7 Days", value: "week", key: "week" },
                  { label: "24 Hours", value: "day", key: "day" },
                  {
                    label: "Custom",
                    value: "custom",
                    key: "custom",
                    secondaryMenu: this.renderCalendarPicker,
                  },
                ]}
                onChange={e => {}}
                noUnset={true}
                label="Time Range"
                defaultValue={"allTime"}
                component={DropDownInput}
              />
              <Field
                component={DropDownInput}
                label="Device"
                name="device"
                options={this.mapSelectToDropDownOptions(device, true)}
                className="form-control"
              />
              <Field
                component={DropDownInput}
                name="app"
                label="App"
                className="form-control"
                options={this.mapSelectToDropDownOptions(app, true)}
              />
              <Field
                component={DropDownInput}
                name="country"
                label="Country"
                className="form-control"
                options={this.mapCountryToDropDownOptions(countries)}
              />
              <Field
                component={DropDownInput}
                name="os"
                label="OS"
                options={this.mapSelectToDropDownOptions(os, true)}
              />
              <If condition={!isAdvertiser}>
                {this.showDropdown()}
                {this.episodeDropdown(episodes)}
              </If>
              <button
                className={"btn btn-secondary reset-button"}
                onClick={e => {
                  e.preventDefault();
                  this.props.reset();
                  this.props.setShowUUID(null);
                }}>
                <span>Reset All</span>
              </button>
            </div>
          </Col>
        </Row>
        <Field
          component="input"
          name="statsType"
          type="hidden"
          value="downloads"
          className="form-control"
        />
      </Form>
    );
  }

  showDropdown = () => {
    return (
      <div>
        <Field
          component={DropDownInput}
          name="showUUID"
          label="Podcast"
          onChange={(e, showUUID) => {
            this.props.clearEpisodeUUID();
            this.props.setShowUUID(showUUID);
            showUUID && this.props.fetchEpisodesForShow(showUUID, this.props.user);
          }}
          disabled={this.props.currentTab === "podcasts"}
          options={
            this.props.currentTab !== "podcasts" &&
            this.props.shows &&
            Object.keys(this.props.shows).length &&
            Object.keys(this.props.shows)
              .filter(showUUID => this.props.shows[showUUID].isVisible)
              .map(showUUID => ({
                value: showUUID,
                label: this.props.shows[showUUID].title,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))
          }
        />
      </div>
    );
  };

  episodeDropdown = episodes => {
    return (
      <div>
        <Field
          component={DropDownInput}
          name="episodeUUID"
          label="Episode"
          disabled={
            !this.props.selectedShowUUID ||
            !episodes ||
            this.props.currentTab === "podcasts" ||
            this.props.currentTab === "episodes"
          }
          options={
            this.props.currentTab !== "podcasts" &&
            this.props.currentTab !== "episodes" &&
            episodes &&
            episodes.map(episode => ({
              value: episode.uuid,
              label: episode.title,
            }))
          }
        />
      </div>
    );
  };

  getEpisodesArray() {
    var episodeInfo =
      this.props.selectedShowUUID &&
      this.props.episodesByShow &&
      this.props.episodesByShow[this.props.selectedShowUUID];
    var episodeMap = episodeInfo && episodeInfo.episodes;
    var episodes;
    if (episodeMap) {
      episodes = [];
      for (var uuid of Object.keys(episodeMap)) {
        episodes.push(episodeMap[uuid]);
      }
      episodes.sort(function(a, b) {
        return a.publishedAt < b.publishedAt ? -1 : a.publishedAt > b.publishedAt ? 1 : 0;
      });
    }
    return episodes;
  }
}

let StatsFilterFormWrapper = reduxForm({
  onChange: (spaceHodlerA, spaceHolderB, props) => props.handleSubmit(),
  form: "stats-filter",
})(StatsFilterForm);
StatsFilterFormWrapper = seedcastForm(StatsFilterFormWrapper);

export default StatsFilterFormWrapper;
